import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  barStyle: {
    display: 'flex', 
    padding: '10px 0px 30px 0px'
  },
  iconDiv: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', paddingLeft: 15 },
  whiteSpace: { flex: 1 },
  buttonStyle: {
    backgroundColor: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.87)',
    color: 'rgba(0, 0, 0, 0.87)'
  }
}));

export default styles;
